import React from "react";
import PropTypes from "prop-types";

// Variantes de color de marca (barra lateral + tile de icono + glow)
const VARIANTS = {
  primary: { bar: "from-sirius-500 to-spark-500", tile: "from-sirius-600 to-spark-500", glow: "bg-spark-500/10" },
  success: { bar: "from-emerald-500 to-teal-500", tile: "from-emerald-600 to-teal-500", glow: "bg-emerald-500/10" },
  warning: { bar: "from-amber-500 to-orange-500", tile: "from-amber-500 to-orange-500", glow: "bg-amber-500/10" },
  danger:  { bar: "from-rose-500 to-red-500",     tile: "from-rose-600 to-red-600",     glow: "bg-red-500/10" },
  accent:  { bar: "from-ink-700 to-ink-900",      tile: "from-ink-800 to-ink-900",      glow: "bg-ink-900/10" },
};

export default function CardStats({
  statSubtitle,
  statTitle,
  statArrow,
  statPercent,
  statPercentColor,
  statDescripiron,
  statIconName,
  statIconColor,
  variant = "primary",
  className = "",
  collapsed = false,
}) {
  const v = VARIANTS[variant] || VARIANTS.primary;

  return (
    <div
      className={`group relative flex flex-col h-full min-w-0 bg-white rounded-2xl border border-slate-200/70 shadow-sm hover:shadow-sirius hover:-translate-y-0.5 transition-all duration-300 overflow-hidden ${className}`}
    >
      {/* Barra lateral de color */}
      <span className={`absolute left-0 top-0 h-full w-1 bg-gradient-to-b ${v.bar}`} />
      {/* Glow al hover */}
      <span className={`pointer-events-none absolute -top-16 -right-16 w-40 h-40 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${v.glow}`} />

      <div className="relative flex-auto p-5 pl-6 flex flex-col justify-between">
        <div className="flex flex-wrap items-start gap-y-2">
          {/* Texto */}
          <div className="flex-1 min-w-0 pr-4">
            <h5 className="text-ink-400 uppercase font-display font-semibold tracking-[0.1em] text-[0.68rem]">
              {statSubtitle}
            </h5>

            <span
              className={`
                block font-display font-bold text-ink-900
                whitespace-nowrap leading-tight mt-1.5
                ${collapsed
                  ? "text-[clamp(1.35rem,2.3vw,2rem)]"
                  : "text-[clamp(1.1rem,1.6vw,1.5rem)]"
                }
              `}
            >
              {statTitle}
            </span>
          </div>

          {/* Ícono en tile gradiente */}
          <div className="flex-shrink-0 ml-auto">
            <div
              className={`text-white inline-flex items-center justify-center w-11 h-11 rounded-xl shadow-spark bg-gradient-to-br ${v.tile}`}
            >
              <i className={statIconName}></i>
            </div>
          </div>
        </div>

        {/* Footer */}
        {(statPercent || statDescripiron) && (
          <p className="text-sm text-ink-400 mt-4 flex items-center flex-wrap">
            <span className={`${statPercentColor} mr-2 whitespace-nowrap font-semibold`}>
              <i
                className={
                  statArrow === "up"
                    ? "fas fa-arrow-up"
                    : statArrow === "down"
                    ? "fas fa-arrow-down"
                    : ""
                }
              ></i>{" "}
              {statPercent}%
            </span>
            <span className="break-words">{statDescripiron}</span>
          </p>
        )}
      </div>
    </div>
  );
}

CardStats.propTypes = {
  statSubtitle: PropTypes.string,
  statTitle: PropTypes.node,
  statArrow: PropTypes.string,
  statPercent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  statPercentColor: PropTypes.string,
  statDescripiron: PropTypes.string,
  statIconName: PropTypes.string,
  statIconColor: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  collapsed: PropTypes.bool,
};
